// §4.4 partial — checkout routes. Composer auto-collects into routes.generated.ts.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";

const CheckoutPage = lazyWithRetry(() => import("./pages/CheckoutPage"));
const CheckoutReturnPage = lazyWithRetry(
  () => import("./pages/CheckoutReturnPage"),
);
const ComprarPage = lazyWithRetry(() => import("./pages/ComprarPage"));

const routes: RouteObject[] = [
  { path: "/comprar", Component: ComprarPage },
  { path: "/checkout", Component: CheckoutPage },
  { path: "/checkout/return", Component: CheckoutReturnPage },
  { path: "/checkout/status", Component: CheckoutReturnPage },
];

export default routes;
